<script>

import NavigationHeader from '../NavigationHeader.vue';
import Modal from '../shared/Modal.vue';
import ModalSelect from '../shared/ModalSelect.vue';
import ButtonNormal from '@/components/buttons/ButtonNormal.vue';
import RatesService from '@/services/RatesService';
import { required } from 'vuelidate/lib/validators';
import AccountService from '@/services/AccountService';
import { mapGetters } from 'vuex';

export default {
    name: 'Rates',
    components: {
        NavigationHeader,
        Modal,
        ModalSelect,
        ButtonNormal,
    },
    data() {
        return {
            ratesList: [
            {
                id: 11,
                title: 'Fair Flat 1.000 Allnet EU',
                description:
                    '800 Minuten in die Festnetze und\n200 Minuten in die Mobilfunknetze\naller EU-Staaten, Schweiz, USA und Kanada',
                price: '27,90',
            }, {
                id: 12,
                title: 'Fair Flat 5.000 Allnet EU',
                description:
                    '4.000 Minuten in die Festnetze und\n1.000 Minuten in die Mobilfunknetze\naller EU-Staaten, Schweiz, USA und Kanada',
                price: '119,90',
            }, {
                id: 13,
                title: 'Fair Flat 10.000 Allnet EU',
                description:
                    '8.000 Minuten in die Festnetze und\n2.000 Minuten in die Mobilfunknetze\naller EU-Staaten, Schweiz, USA und Kanada',
                price: '199,90',
            }, {
                id: 14,
                title: 'Fair Flat 300 mobile EU',
                description: '300 Minuten in die Mobilfunknetz\naller EU-Staaten, Schweiz, USA und Kanada',
                price: '29,90',
            }, {
                id: 15,
                title: 'Fair Flat 500 mobile EU',
                description: '500 Minuten in die Mobilfunknetz\naller EU-Staaten, Schweiz, USA und Kanada',
                price: '49,90',
            }, {
                id: 16,
                title: 'Fair Flat 1000 mobile EU',
                description: '1.000 Minuten in die Mobilfunknetz\naller EU-Staaten, Schweiz, USA und Kanada',
                price: '99,90',
            }, {
                id: 17,
                title: 'Nutzerbezogene Full Flat National',
                description:
                    'Alle Gespräche in das deutsche Fest- & Mobilfunknetz für 9,90€ pro User und Monat.',
                price: '9,90',
              }],
            priceListLink: `https://starface-up.com/tarifliste-starface-up`,
            block_actions: undefined,
            already_canceld: false,
            cancel_date: null,
            start_month: null,
            activeRateId: null,
            selectedRate: null,
            isModalVisible: false,
            isModalSelectVisible: false,
            orderDate: null,
            rateTitleForModal: null,
            modalHeader: '',
            modalBody: '',
            modalConfirmText: '',
            modalAction: null,
            SELECT_NOW: 2,
            SELECT_NEXT_MONTH: 1,
            selectData: {
                id: 1,
                type: 2
            },
            cancelData: {
                cancel: true,
                id: 1
            },
            isSubmittedPopup: false,
            accountInfo: null,
            isIbanSet: false,
            iban: '',
        };
    },
    validations: {
        iban: {
            required,
        }
    },
    created() {
        this.updateCurrentState();
        this.getAccount();
    },
    methods: {
        getAccount() {
            AccountService.getAccount().then(responseAccount => {
                if (responseAccount.data != null) {
                    this.accountInfo = responseAccount.data;
                    this.checkIfIbanIsSet();
                }
            });
        },
        checkIfIbanIsSet() {
            if (this.accountInfo.iban !== '') {
                this.isIbanSet = true;
            }
        },
        updateCurrentState() {
            RatesService.getRates()
            .then((responseRates) => {
                this.start_month = responseRates.data.packages[0].start_month;
                if (responseRates.data.active) {
                    this.activeRateId = parseInt(responseRates.data.active.id, 10);
                    this.block_actions = responseRates.data.active.block_actions;
                    this.already_canceld = responseRates.data.active.already_canceld;
                    this.cancel_date = responseRates.data.active.cancel_date;
                    // console.log(this.activeRateId, this.block_actions, this.already_canceld, this.cancel_date);
                } else {
                    // console.log(' This is just false!');
                }
            });
        },
        openSelectDialog(rate) {
            this.rateTitleForModal = rate.title;
            this.modalHeader = `Möchtest Du die ${rate.title} bestellen?`;
            this.modalConfirmText = 'Kostenpflichtig bestellen';
            this.selectedRate = rate;
            this.openModalSelect();
        },
        select(rate) {
            this.selectData.id = rate.id;
            this.selectData.type = this.SELECT_NEXT_MONTH;
            RatesService.updateRates(this.selectData)
            .then((responseUpdate) => {
                if (responseUpdate.status === 200) {
                    this.$toasted.global.starface_success({message: 'Tarif gewechselt', icon: 'RATES'});
                    this.updateCurrentState();
                } else {
                    this.$toasted.global.starface_error({message: 'Tarif konnte nicht gewechselt werden', icon: 'RATES'});
                }
            });
        },
        openCancelDialog(rate) {
            this.modalHeader = `Möchtest Du die ${rate.title} wirklich kündigen?`;
            this.modalBody = `Die Kündigung erfolgt zum ` + this.cancel_date + `.`;
            this.modalConfirmText = 'Flat Kündigen';
            this.modalAction = () => this.cancel(rate);
            this.openModal();
        },
        cancel(rateToCancel) {
            this.selectedRate = rateToCancel;
            this.cancelData.id = rateToCancel.id;
            RatesService.updateRates(this.cancelData)
            .then((responseUpdate) => {
                if (responseUpdate.status === 200) {
                    this.$toasted.global.starface_success({message: '' + this.selectedRate.title + ' gekündigt', icon: 'RATES'});
                    this.updateCurrentState();
                } else {
                    this.$toasted.global.starface_error({message: 'Tarif konnte nicht gekündigt werden', icon: 'RATES'});
                }
            });
        },
        openSwitchDialog(rate) {
            this.modalHeader = `Möchtest Du zur ${rate.title} wechseln`;
            this.modalBody = `Der Wechsel erfolgt ab ` + this.start_month + `.`;
            this.modalConfirmText = 'Kostenpflichtig wechseln';
            this.modalAction = () => this.select(rate);
            this.openModal();
        },
        openModal() {
            this.isModalVisible = true;
        },
        openModalSelect() {
            this.isModalSelectVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        closeModalSelect() {
            this.isModalSelectVisible = false;
        },
        confirmModal() {
            this.isModalVisible = false;
            this.modalAction();
        },
        confirmModalSelect(orderDate) {
            this.isModalSelectVisible = false;
            this.selectData.id = this.selectedRate.id;
            this.selectData.type = parseInt(orderDate, 10);
            RatesService.updateRates(this.selectData)
            .then((responseUpdate) => {
                if (responseUpdate.status === 200) {
                    this.$toasted.global.starface_success({message: '' + this.selectedRate.title + ' erfolgreich gebucht', icon: 'RATES'});
                    this.updateCurrentState();
                } else {
                    this.$toasted.global.starface_error({message: 'Tarif konnte nicht gebucht werden', icon: 'RATES'});
                }
            });
        },
        confirmModalForIbanCheck(orderDate) {
            if (!this.isIbanSet) {
                this.saveIban(orderDate);
            }
            if (this.isIbanSet) {
                this.isModalSelectVisible = false;
                this.confirmModalSelect(orderDate);
            }
        },
        saveIban(orderDate) {
            this.isSubmittedPopup = true;
            if (!this.$v.iban.$invalid) {
                this.accountInfo.iban = this.iban;

                AccountService.updateAccount(this.accountInfo).then(responseAccount => {
                    if (responseAccount.data.success != null) {
                        this.isModalSelectVisible = false;
                        this.getAccount();
                        this.confirmModalSelect(orderDate);
                    } else {
                        this.$toasted.global.starface_error({
                            message: 'IBAN konnte nicht gespeichert werden. Bitte überprüfe Deine IBAN.',
                            icon: 'RATES',
                        });
                    }
                })
                .catch(error => {
                    this.$toasted.global.starface_error({
                        message: 'IBAN konnte nicht gespeichert werden.',
                        icon: 'RATES',
                    });
                });
            }

        },
    }
};
</script>

<template>
<div class="container">
    <div id="rates">
        <NavigationHeader route="/" navigationText="Zum Dashboard" title="Tarif wählen" />
        <div class="hint">
            <span><b>Neu: Wähle Deine Fair Flat. Bis zu 48 % günstiger telefonieren!</b>
                <br>Die Flats kannst Du jederzeit mit <b>30 Tagen</b> zum Monatsende kündigen.
                <br>Die vollständige Preisliste findest du <a class="price-list" :href="priceListLink" target="_blank">hier</a>.
            </span>
        </div>
        <div v-if="block_actions" class="block-actions">
            <span>Du kannst keine Änderungen bis zum nächsten Abrechnungszeitraum vornehmen.</span>
        </div>
        <div id="rates-grid">
            <div class="tile" :style="{msGridColumn: (2 * index + 1) % 6, msGridRow: 2 * Math.floor(index / 3) + 1}" v-for="(rate, index) in ratesList" v-if="rate" :key="rate.id">
                <div class="header">
                    <div class="icon">
                        <img v-if="index<3" src="@/assets/starface_icons_png/24/orange/phoneMobile_24.png" alt="Phone Mobile Icon">
                        <img v-else src="@/assets/starface_icons_png/24/orange/mobile_2_24.png" alt="Mobile Icon">
                    </div>
                    <div class="badge" v-if="rate.id === activeRateId">
                        <img src="@/assets/starface_icons_png/48/white/tick_48.png" alt="Check mark">
                    </div>
                </div>
                <div class="title">{{rate.title}}</div>
                <p class="description">{{rate.description}}</p>
                <div class="price">{{rate.price}} €/Monat</div>
                <ButtonNormal @onClick="activeRateId ? openSwitchDialog(rate) : openSelectDialog(rate)" v-if="rate.id !== activeRateId && block_actions === undefined" buttonTitle="Jetzt verbindlich bestellen" cssClass="btn btn-primary"/>
                <ButtonNormal @onClick="openCancelDialog(rate)" v-if="rate.id === activeRateId && !already_canceld && block_actions === undefined" buttonTitle="Tarif kündigen" cssClass="btn btn-secondary"/>
                <div class="cancel" v-if="rate.id === activeRateId && already_canceld">
                    <span>Tarif gekündigt zum {{cancel_date}}</span>
                </div>
                <div class="footer">
                    <span v-if="rate.id === activeRateId && !already_canceld">Tarif kündbar zum {{cancel_date}}</span>
                    <span v-if="activeRateId && rate.id !== activeRateId && block_actions === undefined">Tarif-Wechsel möglich ab {{start_month}}</span>
                </div>
            </div>
        </div>
        <Modal v-show="isModalVisible" :is-red="false" :cancelButtonText="'Abbrechen'" :confirmationButtonText="this.modalConfirmText" @close="closeModal" @confirm="confirmModal">
            <template slot="header">{{this.modalHeader}}</template>
            <template slot="body"><div style="padding: 0 20px" v-html="this.modalBody"></div></template>
        </Modal>
        <ModalSelect v-show="isModalSelectVisible" :title="rateTitleForModal" :startMonth="start_month" :cancelButtonText="'Abbrechen'" :confirmationButtonText="this.modalConfirmText" @close="closeModalSelect" @confirm="confirmModalForIbanCheck($event)">
            <template slot="header">{{this.modalHeader}}</template>
            <template slot="additional">
                <div class="iban-modal">
                    <form  v-if="!isIbanSet" class="form">
                        <p>Für die Aktivierung benötigen wir Deine Bankverbindung.<br> Bitte trage hier Deine IBAN ein:</p>
                        <div class="form-group form-text iban">
                            <label for="iban">IBAN:</label>
                            <input class="form-control" type="text" name="iban" id="iban"
                                   v-bind:class="{ 'has-error': isSubmittedPopup && $v.iban.$invalid }"
                                   v-model="iban" required/>
                            <span class="error-message" v-if="isSubmittedPopup && $v.iban.$invalid">Bitte gebe Deine IBAN ein.</span>
                        </div>
                    </form>
                </div>
            </template>
        </ModalSelect>
    </div>
</div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";
@import '../../assets/scss/buttons.scss';
@import '../../assets/scss/inputs.scss';
@import '../../assets/scss/forms.scss';

#rates {
    color: $text;
    font-size: 18px;
    z-index: 1;
    .hint {
        background-color: rgba(245,156,0,0.3);
        padding: 4px 16px;
        margin-bottom: 30px;
        .price-list {
            text-decoration: underline;
            color: $orange;
        }
        
    }
    .block-actions {
        color: $red;
        border: 1px solid $red;
        margin-bottom: 16px;
        padding: 4px 16px;
        text-align: center;
    }
    #rates-grid {
        display: grid;
        display: -ms-grid;
        grid-template-columns: 1fr 1fr 1fr;
        -ms-grid-columns: 1fr 24px 1fr 24px 1fr;
        -ms-grid-rows: 1fr 24px 1fr;
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        .tile {
            position: relative;
            max-width: 309px;
            min-height: 287px;
            padding: 16px;
            background-color: white;
            box-shadow: 0 10px 45px 0 $tile-shadow;
            .header {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding-bottom: 14.18px;
                .icon {
                    height: 23.82px;
                    width: 56.71px;
                }
                .badge {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 83px;
                    height: 83px;
                    border-bottom-left-radius: 100%;
                    background-color: $orange;
                    img {
                        height: 37.31px;
                        width: 41.84px;
                        margin: 13px 9.16px 32.69px 32px; 
                    }
                }
            }
            .title {
                width: 100%;
                font-weight: bold;
                line-height: 24px;
            }
            .description {
                width: 100%;
                min-height: 38px;
                font-size: 13.9px;
                line-height: 19px;
                margin-top: 24px;
                white-space: pre-line;
            }
            .price {
                width: 100%;
                font-weight: bold;
                line-height: 24px;
                text-align: right;
                margin-top: 16px;
            }
            button {
                width: 100%;
                margin-top: 16px;
            }
            .cancel {
                margin-top: 29px;
                .btn-tertiary {
                    width: auto;
                    float: right;
                    margin-top: 8px;
                    font-size: 16px;
                    line-height: 22px;
                }
            }
            .footer {
                width: 100%;
                color: $grey-middle;
                font-size: 14px;
                line-height: 19px;
                margin-top: 8px;
            }
        }
    }
    .error-message {
        font-size: 12px;
        font-weight: 600;
        text-align: left;
        color: $red;
    }
    .has-error {
        border-color: #f54d00;
    }
}
</style>
